<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="documentSubProcessState.loading"
          :style="{ opacity: documentSubProcessState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay documentos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'documentSubProcessState'
    ]),
    optionSelected() {
      return this.documentSubProcessState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.documentSubProcessState.list.length
        || this.documentSubProcessState.loading;
    },
    listOptions() {
      return this.documentSubProcessState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchDocumentSubProcess'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.$emit('change', event?.value);
    },
    getOption() {
      return this.documentSubProcessState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    if (this.nested) {
      // TODO: this.clearDocuments();
      this.$watch('parentValue', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if (oldValue !== '') {
            this.$emit('input', '');
          }
          this.fetchDocumentSubProcess({
            parentId: newValue,
            company: this.companyToLoad,
            group: this.group
          });
        }
      });

      if (this.parentValue) {
        this.fetchDocumentSubProcess({
          parentId: this.parentValue,
          company: this.companyToLoad,
          group: this.group
        });
      }
    } else {
      this.fetchDocumentSubProcess({
        parentId: this.parentValue,
        company: this.companyToLoad,
        group: this.group
      });
    }
  },
  props: {
    group: { type: String, default: 'procesos-siss' },
    name: { type: String, required: true },
    label: { type: String, default: 'Documentos' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    nested: { type: Boolean, default: true },
    parentValue: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    companyToLoad: {
      type: String,
      required: false,
      default: null
    },
    typeNumeration: { type: String }
  }
};

</script>
